<td>{{getSocietyDescriptionById societyId}}</td>
<td>{{getLocaleText name}}</td>
<td class="tools">
	<a href class="unassign" title="Unassign" data-id="{{id}}"><i class="icon-trash"></i></a>
</td>
